import { faCog, faPlus, faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, MenuItem, Radio, RadioGroup, Select, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Page from '../../component/Page'
import { SETTING_CONFIG } from './config.'
import { getBranchList } from './services/settingApi'
import './wherehouse.scss'
import api from '../../api/api'
import { useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import RequireField from '../../component/RequireField'

export default function Wherehouse() {
    const [BranchNo, setBranchsNo] = useState('')
    const [Name, setName] = useState('')
    const [No, setNo] = useState('')
    const [data, setData] = useState()
    const [open, setOpen] = useState(false)
    const [openType, setOpenType] = useState()
    const [Status, setStatus] = useState('Y')
    const [branchs, setBranchs] = useState([])
    const { profile, loading } = useSelector(state => state.profile)
    const [nameError, setNameError] = useState(false);

    const [WherehouseId, setWherehouseId] = useState('')
    const [WherehouseList, setWherehouseList] = useState([])
    const [ZoneList, setZoneList] = useState([])
    const getWherehouseList = async () => {
        const url = SETTING_CONFIG.requests.getBranchs.url + `/${BranchNo || profile?.BranchNo?.BranchNo}/warehouses`;
        const res = await api.get(url)
        const data = res.data
        if (data.status === true) {
            setWherehouseList(data.result)
            setWherehouseId(data.result[0].WarehouseNo)
        }
    }
    const getZoneList = async () => {
        const url = SETTING_CONFIG.requests.getBranchs.url + `/${BranchNo || profile?.BranchNo?.BranchNo}/zones`;
        const res = await api.get(url)
        const data = res.data
        if (data.status === true) {
            setZoneList(data.result)
        }
    }

    useEffect(() => {
        getBranchList(null, setBranchs)
        setBranchsNo(profile?.BranchNo?.BranchNo)
    }, [])
    useEffect(() => {
        getWherehouseList()
        getZoneList()
    }, [BranchNo])
    const Open = (x, type) => {
        if (type === 'W') {
            setNo(x?.WarehouseNo)
            setName(x?.WarehouseName)
        }
        if (type === 'S') {
            setNo(x?.ZoneNo)
            setName(x?.ZoneName)
        }
        setData(x)
        setOpenType(type)
        setStatus(x?.Status || 'Y')
        setOpen(true)
    }
    const Close = () => {
        setOpenType()
        setData()
        setOpen(false)
        setName('')
        setNo('')
        setStatus('Y')
        setNameError(false)
    }
    return (
        <Page>
            <div class="container-fluid">

                <div class="row" >
                    <div class="col-lg-4 col-sm-12">
                        <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                        <Box className='backgroundField' sx={{ marginBottom: '20px' }}>
                            <FormControl variant="standard" fullWidth >
                                <Select value={BranchNo} onChange={e => setBranchsNo(e.target.value)} disableUnderline >
                                    {branchs?.map((x) => (
                                        <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                    </div>
                </div>
                <div class="row" >
                    <div class="col-sm-12 col-lg-6">
                        <div class="border-row" >
                            <div class=" d-flex justify-content-between">
                                <div >
                                    <label class="title-content">โรงเก็บ</label>
                                </div>
                                <div onClick={() => Open(null, 'W')} >
                                    <FontAwesomeIcon icon={faPlusCircle} />
                                </div>
                            </div>
                            <div class="row mt-2" >
                                <div class="Warehouse col-12">
                                    <div class="table-responsive-sm">
                                        <table class="table table-borderless table-hover">
                                            <thead>
                                                <tr>
                                                    <th class="text-center">สถานะ</th>
                                                    <th class="text-center">รหัสโรงเก็บ</th>
                                                    <th class="text-center">ชื่อโรงเก็บ</th>
                                                    <th ></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {WherehouseList?.map((x) => (
                                                    <tr class={`${x?.WarehouseNo === WherehouseId ? 'active' : ''}`} onClick={() => setWherehouseId(x?.WarehouseNo)}>
                                                        <td class="text-center">
                                                            {x?.Status === 'Y' ? <span class="status-active">
                                                                ใช้งาน
                                                            </span> :
                                                                <span class="status-inactive">
                                                                    ไม่ใช้งาน
                                                                </span>}
                                                        </td>
                                                        <td class="text-center">{x?.WarehouseNo}</td>
                                                        <td class="text-center">{x?.WarehouseName}</td>
                                                        <td class="text-center"><FontAwesomeIcon icon={faCog} className='icon' style={{ cursor: 'pointer' }} onClick={() => Open(x, 'W')} /></td>
                                                    </tr>
                                                ))}

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-lg-6">
                        <div class="border-row">
                            <div class=" d-flex justify-content-between">
                                <div >
                                    <label class="title-content">โซน</label>
                                </div>
                                <div onClick={() => Open(null, 'S')}>
                                    <FontAwesomeIcon icon={faPlusCircle} />

                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="listData col-12">
                                    <div class="table-responsive-sm">
                                        <table class="table table-borderless table-hover">
                                            <thead>
                                                <tr>
                                                    <th class="text-center">สถานะ</th>
                                                    <th class="text-center">รหัสโซน</th>
                                                    <th class="text-center">ชื่อโซน</th>
                                                    <th ></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {ZoneList?.filter((y) => y?.WarehouseNo?.WarehouseNo === WherehouseId).map((x) => (
                                                    <tr class="cp">
                                                        <td class="text-center">
                                                            {x?.Status === 'Y' ? <span class="status-active" >
                                                                ใช้งาน
                                                            </span> :
                                                                <span class="status-inactive">
                                                                    ไม่ใช้งาน
                                                                </span>}
                                                        </td>
                                                        <td class="text-center">{x?.ZoneNo}</td>
                                                        <td class="text-center">{x?.ZoneName}</td>
                                                        <td class="text-center"><FontAwesomeIcon icon={faCog} className='icon' style={{ cursor: 'pointer' }} onClick={() => Open(x, 'S')} /></td>
                                                    </tr>
                                                ))}

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <Dialog
                open={open}
                // onClose={Close}
                fullWidth
                maxWidth='md'
            >
                <DialogTitle id="alert-dialog-title">
                    {openType === 'W' ? No ? 'แก้ไขโรงเก็บ' : 'เพิ่มโรงเก็บ' : No ? 'แก้ไขโซน' : 'เพิ่มโซน'}
                </DialogTitle>
                <DialogContent>
                    <div class="row" style={{ marginBottom: '10px' }}>
                        {data ? <>
                            <div class="col-lg-6 col-md-12">
                                <label class="labelInput">{openType === 'W' ? 'รหัสโรงเก็บ' : 'รหัสโซน'}</label>
                                <Box className='backgroundField' >
                                    <TextField disabled value={No || ''} onChange={e => setNo(e.target.value)} variant="standard" fullWidth
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />

                                </Box>

                            </div>
                            <div class="col-lg-6 col-md-12">
                                <label class="labelInput">{openType === 'W' ? 'ชื่อโรงเก็บ' : 'ชื่อโซน'}</label>

                                <RequireField value={Name} onChange={setName} type={'text'} error={nameError} setError={setNameError} textError={openType === 'W' ? 'กรุณากรอกชื่อโรงเก็บ' : openType === 'S' ? 'กรุณากรอกชื่อโซน' : ''} />

                            </div></> : <div class="col-lg-12 col-md-12">
                            <label class="labelInput">{openType === 'W' ? 'ชื่อโรงเก็บ' : 'ชื่อโซน'}</label>

                            <RequireField value={Name} onChange={setName} type={'text'} error={nameError} setError={setNameError} textError={openType === 'W' ? 'กรุณากรอกชื่อโรงเก็บ' : openType === 'S' ? 'กรุณากรอกชื่อโซน' : ''} />

                        </div>}

                    </div>
                    <div class="row">

                        <RadioGroup row value={Status || ''} onChange={e => setStatus(e.target.value)}>
                            <FormControlLabel value="Y" control={<Radio />} label="ใช้งาน" />
                            <FormControlLabel value="N" control={<Radio />} label="ไม่ใช้งาน" />
                        </RadioGroup>

                    </div>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' sx={{ width: '120px' }} onClick={Close}>ปิด</Button>
                    <Button variant='contained' sx={{ width: '120px' }} onClick={() => {
                        if (openType === 'W') {
                            const body = {
                                WarehouseId: data?.WarehouseId || null,
                                WarehouseName: Name,
                                WarehouseNo: No,
                                BranchNo: BranchNo,
                                Status: Status
                            }

                            const wherehouseAdd = async () => {

                                if (body?.WarehouseId) {
                                    const url = SETTING_CONFIG.requests.getWherehouses.url + `/${body?.WarehouseNo}`;
                                    const res = await api.put(url, body)
                                    const data = res.data
                                    if (data.status === true) {
                                        Close()
                                        getWherehouseList()
                                        Swal.fire(
                                            'ทำรายการสำเร็จ',
                                            '',
                                            'success'
                                        )
                                    } else {
                                        Swal.fire({
                                            title: data?.message || 'ทำรายการไม่สำเร็จ',
                                            icon: 'warning',
                                        })
                                    }
                                } else {

                                    const res = await api.post(SETTING_CONFIG.requests.getWherehouses.url, body)
                                    const data = res.data
                                    if (data.status === true) {
                                        Close()
                                        getWherehouseList()
                                        Swal.fire(
                                            'ทำรายการสำเร็จ',
                                            '',
                                            'success'
                                        )
                                    } else {
                                        Swal.fire({
                                            title: data?.message || 'ทำรายการไม่สำเร็จ',
                                            icon: 'warning',
                                        })
                                    }

                                }
                            }
                            if (!Name) {
                                setNameError(true)
                            } else {
                                wherehouseAdd()
                            }
                        }
                        if (openType === 'S') {
                            const body = {
                                ZoneId: data?.ZoneId || null,
                                ZoneName: Name,
                                WarehouseNo: WherehouseId,
                                Status: Status,
                                ZoneNo: No
                            }

                            const zoneAdd = async () => {

                                if (body?.ZoneId) {
                                    const url = SETTING_CONFIG.requests.getZones.url + `/${body?.ZoneNo}`;
                                    const res = await api.put(url, body)
                                    const data = res.data
                                    if (data.status === true) {
                                        Close()
                                        getZoneList()
                                        Swal.fire(
                                            'ทำรายการสำเร็จ',
                                            '',
                                            'success'
                                        )
                                    } else {
                                        Swal.fire({
                                            title: data?.message || 'ทำรายการไม่สำเร็จ',
                                            icon: 'warning',
                                        })
                                    }

                                } else {
                                    const res = await api.post(SETTING_CONFIG.requests.getZones.url, body)
                                    const data = res.data
                                    if (data.status === true) {
                                        Close()
                                        getZoneList()
                                        Swal.fire(
                                            'ทำรายการสำเร็จ',
                                            '',
                                            'success'
                                        )
                                    } else {
                                        Swal.fire({
                                            title: data?.message || 'ทำรายการไม่สำเร็จ',
                                            icon: 'warning',
                                        })
                                    }
                                }

                            }
                            if (!Name) {
                                setNameError(true)
                            } else {
                                zoneAdd()
                            }

                        }
                    }} >
                        บันทึก
                    </Button>
                </DialogActions>
            </Dialog>
        </Page>
    )
}
